document.addEventListener('DOMContentLoaded', function () {
    const starUrls = {
        full: "https://cdn.shopify.com/s/files/1/0558/0514/9316/files/Stella_piena.png?v=1746024172",
        half: "https://cdn.shopify.com/s/files/1/0558/0514/9316/files/Mezza_stella.png?v=1746024260",
        empty: "https://cdn.shopify.com/s/files/1/0558/0514/9316/files/Stella_vuota.png?v=1746024187"
    };

    const csvUrl = "https://cdn.shopify.com/s/files/1/0558/0514/9316/files/Recensioni_prodotto.csv?v=1746011767";

    Papa.parse(csvUrl, {
        download: true,
        complete: function (results) {
            const reviewsData = results.data.slice(1); // skip header

            const reviewsMap = {};
            for (const row of reviewsData) {
                const sku = String(row[0]).trim();
                const rating = parseInt(row[2] || 0);
                if (!reviewsMap[sku]) reviewsMap[sku] = [];
                reviewsMap[sku].push(rating);
            }

            const reviewContainers = document.querySelectorAll('.product-card__review-summary');

            reviewContainers.forEach(container => {
                const sku = container.dataset.sku ? container.dataset.sku.trim() : ''; // Rimuovo il punto interrogativo
                const ratings = reviewsMap[sku];

                if (ratings && ratings.length > 0) {
                    const total = ratings.reduce((a, b) => a + b, 0);
                    const avg = (total / ratings.length).toFixed(1);

                    const fullStars = Math.floor(avg);
                    const hasHalfStar = avg % 1 >= 0.5 ? 1 : 0;
                    const emptyStars = 5 - fullStars - hasHalfStar;

                    let starHtml = '';
                    for (let i = 0; i < fullStars; i++) {
                        starHtml += `<img src="${starUrls.full}" alt="stella piena" class="star-image">`;
                    }
                    if (hasHalfStar) {
                        starHtml += `<img src="${starUrls.half}" alt="mezza stella" class="star-image">`;
                    }
                    for (let i = 0; i < emptyStars; i++) {
                        starHtml += `<img src="${starUrls.empty}" alt="stella vuota" class="star-image">`;
                    }

                    container.innerHTML = `
                        <div class="review-stars" style="display: flex; align-items: center; margin-top: 4px;">
                            ${starHtml}
                            <span style="font-size: 11px; color: #777; margin-left: 4px;">(${ratings.length})</span>
                        </div>
                    `;

                    container.querySelectorAll('.star-image').forEach(img => {
                        img.style.width = '15px';
                        img.style.height = '15px';
                        img.style.marginRight = '2px';
                    });
                }
            });
        },
        error: function (error) {
            console.error("Errore nel caricamento del CSV recensioni:", error);
        }
    });
});
